import { Children, ReactNode, FC } from 'react';

import cn from 'clsx';
import { UIHeading1, UIHeading2 } from '@cian/ui-kit';

import { TITLE_FORM, ETestIds } from '../../constants';
import { useIsDesktop } from '../../hooks/useIsDesktop';

import styles from './styles.css';

export interface IFormProps {
  children: ReactNode;
}

export const Form: FC<IFormProps> = ({ children }) => {
  const isDesktop = useIsDesktop();

  const Title = isDesktop ? UIHeading1 : UIHeading2;

  return (
    <div>
      <Title>{TITLE_FORM}</Title>
      <form className={cn(styles['form'], isDesktop && styles['desktop'])} data-testid={ETestIds.Form}>
        {Children.map(children, child => (
          <div className={styles['field']}>{child}</div>
        ))}
      </form>
    </div>
  );
};

Form.displayName = 'Form';
